@for (case of formattedCheckboxData; track case) {
<div>
  @if (!case.subCheckbox) {
  <div class="restful-checkbox-collection -heading-checkbox">
    <restful-checkbox
      [question]="case"
      [form]="form"
      [hideOptional]="true"
      [hideLabel]="true"
      [bottomSubtext]="true"
      (checkedValue)="setAllDefaults($event)"></restful-checkbox>
  </div>
  } @else {
  <div class="restful-checkbox-collection -sub-checkbox">
    <restful-checkbox [question]="case" [form]="form" [hideOptional]="true" [hideLabel]="true"></restful-checkbox>
  </div>
  }
</div>
}
